import { useEffect, useState } from "react";
import { getDeviceStagedata } from "../services/configurationServices";


export const useDeviceStage = () => {
    const [deviceStage, setDeviceStage] = useState([]);

    useEffect(() => {
        getDeviceStage();
    }, [])

    const getDeviceStage =()=>{
        getDeviceStagedata()
        .then((res) => {
          console.log("DeviceStage ", res)
          if(res.Status == "success"){
            console.log("DeviceStage ", res.Data)
            setDeviceStage(res.Data)
          }else{
            setDeviceStage([])
          }
        }).catch(err => console.log(err))
      }

    return { deviceStage, setDeviceStage };
}

